module.exports = __webpack_public_path__ + "img/Group 1840@2x(3).152a40de.png";